export interface IFees {
    value: number
    isSelected: boolean
}
export const fees: Array<IFees> = [
    {
        value: 0,
        isSelected: true,
    },
    {
        value: 0.5,
        isSelected: false,
    },
    {
        value: 1,
        isSelected: false,
    },
    {
        value: 1.5,
        isSelected: false,
    },
    {
        value: 2,
        isSelected: false,
    },
    {
        value: 2.5,
        isSelected: false,
    },
    {
        value: 3,
        isSelected: false,
    },
    {
        value: 3.5,
        isSelected: false,
    },
    {
        value: 4,
        isSelected: false,
    },
]
